import React from 'react';
import { DModal } from '../../../../../dum';
import { OrderQuotationIcon } from '../../../../icons';
import { OrderQuotationStatusChangeForm } from './order-quotation-status-change-form';

interface ISUpdateOrderQuotationStatusDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderQuotationId: number | null;
    currentStatusId?: number | null;
}

export function SUpdateOrderQuotationStatusDialog({
    open,
    setOpen,
    orderQuotationId,
    currentStatusId,
}: ISUpdateOrderQuotationStatusDialogProps) {
    return (
        <DModal
            icon={<OrderQuotationIcon />}
            title={'Cambiar status de la cotización'}
            open={open}
            setOpen={setOpen}
        >
            {orderQuotationId ? (
                <OrderQuotationStatusChangeForm
                    orderQuotationId={orderQuotationId}
                    currentStatusId={currentStatusId}
                    onSuccess={() => setOpen(false)}
                />
            ) : null}
        </DModal>
    );
}
